// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__C6Xq4","load":"Skeleton_load__uQwWR"};